/* apps/viewer/src/app/extra-doc/extra-doc.component.scss */
:host {
  height: calc(100vh - 60px);
}
/*# sourceMappingURL=extra-doc.component.css.map */
